import { type AttributeValue, attributes, type HtmlValue, html, joinClasses } from 'BomdisoftComponents/html/index';
import { renderTooltip, type TooltipPlacement } from 'BomdisoftComponents/tooltip/render';

export type ExpandableMenuButtonBadgeColor = 'default' | 'error' | 'info' | 'primary' | 'secondary' | 'success' | 'warning';

export type ExpandableMenuButtonOptions = {
  ariaLabel?: string;
  attributes?: Readonly<Record<string, AttributeValue>>;
  badgeColor?: ExpandableMenuButtonBadgeColor;
  badgeContent?: HtmlValue;
  buttonClassName?: string;
  containerClassName?: string;
  expanded?: boolean;
  icon: HtmlValue;
  isActive?: boolean;
  placement?: TooltipPlacement;
  showBadge?: boolean;
  showTooltip?: boolean;
  testId?: string | null;
  text?: string;
  textClassName?: string;
  tooltip?: string;
  tooltipId: string;
};

export const EXPANDABLE_MENU_BUTTON_TEST_ID = 'expandable-menu-icon-button';

export const isLongMenuButtonText = (text: string | undefined) => text !== undefined && text.length > 15;

export const renderExpandableMenuButton = ({
  ariaLabel,
  attributes: extra = {},
  badgeColor = 'default',
  badgeContent = '',
  buttonClassName,
  containerClassName,
  expanded = false,
  icon,
  isActive = false,
  placement = 'top',
  showBadge = false,
  showTooltip = true,
  testId = EXPANDABLE_MENU_BUTTON_TEST_ID,
  text,
  textClassName,
  tooltip,
  tooltipId,
}: ExpandableMenuButtonOptions) => {
  const glyph = showBadge ? html`<span class="bomdisoft-expandable-menu-button-badge-holder">${icon}<span${attributes({ class: 'bomdisoft-expandable-menu-button-badge', 'data-color': badgeColor })}>${badgeContent}</span></span>` : icon;
  const label = text ? html`<span${attributes({ class: joinClasses('bomdisoft-expandable-menu-button-text', textClassName) })}>${text}</span>` : '';
  const button = html`<button${attributes({ ...extra, 'aria-label': ariaLabel || tooltip || text, class: joinClasses('bomdisoft-expandable-menu-button', containerClassName), 'data-testid': testId, type: 'button' })}><span${attributes({ class: joinClasses('bomdisoft-expandable-menu-button-button', buttonClassName), 'data-active': isActive, 'data-expanded': expanded })}>${glyph}${label}</span></button>`;
  return !isLongMenuButtonText(text) && (expanded || !showTooltip) ? button : renderTooltip({ children: button, id: tooltipId, placement, title: tooltip || text });
};
